module.exports = __webpack_public_path__ + "img/compass.633a8a54.png";